import React, { useContext } from "react";
import { styled, keyframes } from "styled-components";
import Flex from "../../../components/Box/Flex";
import { MenuContext } from "../context";

interface Props {
  href: string;
}

const StyledLink = styled("a")`
  display: flex;
  align-items: center;
`;

const BrandText = styled.span`
  margin-left: 10px;
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1;
  color: ${({ theme }) => theme.colors.text};
`;

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
`;

const blink = keyframes`
  0%, 90%, 100% { height: 7px; top: -11px; }
  95% { height: 1px; top: -5px; }
`;

const smileBreath = keyframes`
  0%, 100% { width: 18px; height: 8px; }
  50% { width: 20px; height: 9px; }
`;

const SmileyWrap = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: linear-gradient(145deg, #25cba8, #17b28e);
  box-shadow: 0 4px 14px rgba(31, 180, 148, 0.34);
  flex-shrink: 0;
  animation: ${float} 3s ease-in-out infinite;
`;

const SmileyFace = styled.div`
  position: absolute;
  width: 18px;
  height: 8px;
  border: 3px solid #fff;
  border-top: 0;
  border-radius: 0 0 18px 18px;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  animation: ${smileBreath} 3s ease-in-out infinite;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: -11px;
    width: 5px;
    height: 7px;
    background: #fff;
    border-radius: 999px;
    animation: ${blink} 4s infinite;
  }
  &::before { left: 1px; }
  &::after  { right: 1px; }
`;

const Logo: React.FC<React.PropsWithChildren<Props>> = ({ href }) => {
  const { linkComponent } = useContext(MenuContext);
  const isAbsoluteUrl = href.startsWith("http");
  const innerLogo = (
    <Flex alignItems="center">
      <SmileyWrap><SmileyFace /></SmileyWrap>
      <BrandText>MacSwap</BrandText>
    </Flex>
  );

  return (
    <Flex alignItems="center">
      {isAbsoluteUrl ? (
        <StyledLink as="a" href={href} aria-label="MacSwap home page">
          {innerLogo}
        </StyledLink>
      ) : (
        <StyledLink href={href} as={linkComponent} aria-label="MacSwap home page">
          {innerLogo}
        </StyledLink>
      )}
    </Flex>
  );
};

export default React.memo(Logo);
